import { useEffect, useState } from 'react';
import { MapPin, Globe, Truck } from 'lucide-react';

// Barbados coordinates
const BARBADOS_COORDS = [13.0975, -59.6167];

function MapComponent() {
  const [MapContainer, setMapContainer] = useState(null);
  const [TileLayer, setTileLayer] = useState(null);
  const [Marker, setMarker] = useState(null);
  const [Popup, setPopup] = useState(null);
  const [L, setL] = useState(null);

  useEffect(() => {
    // Dynamic import for client-side only
    import('react-leaflet').then((mod) => {
      setMapContainer(() => mod.MapContainer);
      setTileLayer(() => mod.TileLayer);
      setMarker(() => mod.Marker);
      setPopup(() => mod.Popup);
    });
    import('leaflet').then((mod) => {
      setL(mod.default);
    });
  }, []);

  if (!MapContainer || !TileLayer || !Marker || !Popup || !L) {
    return (
      <div className="w-full h-64 bg-slate-800 rounded-lg flex items-center justify-center">
        <Globe className="h-12 w-12 text-slate-600 animate-pulse" />
      </div>
    );
  }

  // Custom marker icon
  const customIcon = L.divIcon({
    className: 'custom-marker',
    html: `<div style="background: #f97316; width: 24px; height: 24px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 8px rgba(0,0,0,0.3);"></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });

  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      scrollWheelZoom={false}
      style={{ height: '100%', width: '100%', borderRadius: '8px' }}
      className="z-0"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={BARBADOS_COORDS} icon={customIcon}>
        <Popup>
          <div className="text-center">
            <strong>CheepSweepz HQ</strong>
            <br />
            Culloden Road, Bridgetown
            <br />
            St. Michael, Barbados
          </div>
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default function FooterMapSection() {
  const shipFromHubs = [
    { name: 'USA', flag: '🇺🇸' },
    { name: 'Canada', flag: '🇨🇦' },
    { name: 'UK', flag: '🇬🇧' },
    { name: 'Germany', flag: '🇩🇪' },
    { name: 'Italy', flag: '🇮🇹' },
    { name: 'Japan', flag: '🇯🇵' },
  ];

  return (
    <section className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Map */}
          <div className="h-64 lg:h-80 rounded-lg overflow-hidden shadow-xl">
            <MapComponent />
          </div>

          {/* Info */}
          <div className="text-center lg:text-left space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center justify-center lg:justify-start gap-2">
                <Globe className="h-6 w-6 text-orange-500" />
                Global Coverage
              </h3>
              <p className="text-slate-300 text-lg">
                Based in <span className="text-orange-400 font-semibold">Barbados</span> • Serving Worldwide
              </p>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-2 text-slate-400">
              <MapPin className="h-5 w-5 text-orange-500" />
              <span>Culloden Road, Bridgetown, St. Michael, Barbados</span>
            </div>

            <div>
              <p className="text-slate-400 text-sm mb-3 flex items-center justify-center lg:justify-start gap-2">
                <Truck className="h-4 w-4" />
                Ship-from hubs:
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-2">
                {shipFromHubs.map((hub) => (
                  <span
                    key={hub.name}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-800 rounded-full text-sm text-slate-300"
                  >
                    <span>{hub.flag}</span>
                    <span>{hub.name}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
